<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
  <g fill="none">
    <g fill="#78909C">
      <path
        d="M3.6 7.4L7.4 3.5C7.7 3.3 8.2 3.3 8.4 3.5 8.7 3.8 8.7 4.3 8.4 4.6L4.6 8.4C4.3 8.7 3.8 8.7 3.6 8.4 3.3 8.1 3.3 7.7 3.6 7.4ZM3.5 10.2C3 10.7 2.2 10.7 1.8 10.2 1.3 9.8 1.3 9 1.8 8.5L4.8 5.5C3.9 5.2 2.9 5.4 2.2 6.1L0.8 7.6C-0.3 8.6-0.3 10.2 0.8 11.2 1.8 12.3 3.4 12.3 4.4 11.2L5.9 9.8C6.6 9.1 6.8 8.1 6.6 7.2L3.5 10.2ZM11.2 0.8C10.2-0.3 8.6-0.3 7.6 0.8L6.1 2.2C5.4 2.9 5.2 3.9 5.4 4.8L8.5 1.8C9 1.3 9.8 1.3 10.2 1.8 10.7 2.3 10.7 3 10.2 3.4L7.2 6.5C8.2 6.8 9.1 6.5 9.8 5.9L11.2 4.4C12.3 3.4 12.3 1.8 11.2 0.8Z"/>
    </g>
  </g>
</svg>
